import { render } from "./Backwards.vue?vue&type=template&id=619dd358"
import script from "./Backwards.vue?vue&type=script&lang=js"
export * from "./Backwards.vue?vue&type=script&lang=js"
script.render = render

export default script